import { Component, Input } from '@angular/core';
import { FileUploadDto, TicketButtonCommunicationDto } from '../../../../../service/dto';
import { NzModalService } from 'ng-zorro-antd/modal';
import { PreviewModalComponent } from '../../../../../components/preview-modal/preview-modal.component';

@Component({
	selector: 'app-ticket-communication-display-modal',
	standalone: false,
	templateUrl: './ticket-communication-display-modal.component.html',
	styleUrl: './ticket-communication-display-modal.component.scss'
})
export class TicketCommunicationDisplayModalComponent {
	@Input() data!: TicketButtonCommunicationDto;

	constructor(private modalService: NzModalService) { }

	split(input: string | undefined) {
		if (input == undefined || input == null) {
			return undefined;
		}
		return input.split(/[;,]/);
	}

	doPreviewFile(input: FileUploadDto) {
		const modal = this.modalService.create({
			nzTitle: 'Preview',
			nzContent: PreviewModalComponent,
			nzWidth: '75%',
			nzBodyStyle: { height: '80vh', overflow: 'auto' },
			nzFooter: null
		});

		modal.componentInstance!.file = input.uuid;
	}
	canPreview(input: FileUploadDto): boolean {
		return input.fileName.toLowerCase().endsWith(".pdf");
	}
}
